import React from 'react';
import api from '../utils/api';

// PHASE 2 / H — shared meal-image renderer. PASS-THROUGH for normal images (base64 data URLs,
// FatSecret/external https, placeholders). For a private AI-meal marker ("/api/ai-log/photo/{meal_id}")
// it calls the authenticated owner-only resolver via the Axios api client (Bearer on native, cookie on
// web), receives a fresh short-lived signed URL, and renders THAT as the <img src>. The signed URL is
// memory-only (never persisted). Works identically in browser and Capacitor/native builds.
const MARKER = '/api/ai-log/photo/';

// Pure predicate (exported for tests): is this src our private owner-only AI-photo marker that must go
// through the authenticated resolver rather than a raw <img src>?
export function isPrivateMealPhotoMarker(src) {
  return !!src && src.startsWith(MARKER);
}

export function useMealImageSrc(rawSrc) {
  const [resolved, setResolved] = React.useState(() => (isPrivateMealPhotoMarker(rawSrc) ? '' : rawSrc));
  React.useEffect(() => {
    let alive = true;
    if (!isPrivateMealPhotoMarker(rawSrc)) { setResolved(rawSrc); return () => { alive = false; }; }
    setResolved('');
    const mealId = rawSrc.slice(MARKER.length);
    api.get('/ai-log/photo/' + encodeURIComponent(mealId))
      .then((r) => { if (alive && r.data && r.data.signed_url) setResolved(r.data.signed_url); })
      .catch(() => { if (alive) setResolved(''); });   // 404 -> owner mismatch/missing -> no image
    return () => { alive = false; };
  }, [rawSrc]);
  return resolved;
}

export function MealImage({ src, fallback = '', alt = '', ...imgProps }) {
  const resolved = useMealImageSrc(src);
  return <img src={resolved || fallback} alt={alt} {...imgProps} />;
}

export default MealImage;
